// Entry point bundled by esbuild (see esbuild.config.js) into app/assets/builds.

import "@hotwired/turbo-rails"
import Rails from "@rails/ujs"
import "packs/jquery.js"
import "packs/app/sideNav.js"
import "packs/app/messages.js"
import "packs/app/messagesForm.js"

Rails.start()
